<template>
  <comment-count
    v-bind.sync="$attrs"
    :domain-url="$env.IL_DOMAIN_URL"
    :shortname="$env.IL_FL_DISQUS_SHORT_NAME"
    @update:isCommentCounterVisible="
      $emit('update:isCommentCounterVisible', $event)
    "
  />
</template>

<script>
import CommentCount from '../_shared/CommentCount'

export default {
  name: 'IlCommentCount',
  components: { CommentCount }
}
</script>
